//----------------------------------------------Helpers-----------------------------------//
export function toggle_class(button, itemToAddClass, classToAdd, callbakfunction, args) {
    let toggleButton = document.querySelector(button);
    if (toggleButton) {
        toggleButton.addEventListener('click', _toggle_class);
    }
    function _toggle_class() {
        let elementToAddClass = document.querySelector(itemToAddClass);
        if (elementToAddClass) {
            if (classToAdd) {
                elementToAddClass.classList.toggle(classToAdd);
            }
        }
    }
}

function aspect_ratio_resize(element, ratio) {
    let elementWidth = element.clientWidth;
    if (elementWidth && ratio) {
        element.style.height = (elementWidth * (ratio / 100)) + 'px';
    }
}

export function aspect_ratio( element ) {
    let aspect_ratio_elements = document.querySelectorAll( element );
    if ( aspect_ratio_elements ) {
        for (let i = 0; i < aspect_ratio_elements.length; i++) {
            window.addEventListener( 'resize', aspect_ratio_resize.bind( window, aspect_ratio_elements[ i ], 75 ) );
            aspect_ratio_resize( aspect_ratio_elements[ i ], 75 );
        }
    }
}

//JQuery optimization hook for google speed inside
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};